import { Bell } from 'lucide-react';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerBody,
  Empty,
} from '@/v2/design-system/primitives';

export interface NotificationDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Sober DS (v2) — notifications drawer. There is no notifications backend yet,
 * so we show an honest empty state instead of mock items (Story 27.34).
 */
export function NotificationDrawer({ open, onOpenChange }: NotificationDrawerProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <div className="grid size-9 place-items-center rounded-so-sm bg-sober-primary-bg text-sober-primary">
            <Bell className="size-5" />
          </div>
          <DrawerTitle>Notificações</DrawerTitle>
        </DrawerHeader>
        <DrawerBody>
          <Empty
            icon={<Bell />}
            title="Consulte as pendências nas telas de rotina"
            description="Os avisos ainda não estão reunidos aqui. Confira atendimentos na Agenda e cobranças no Financeiro."
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
